/**
 * Zone Compatibility Scoring Constants
 *
 * Used by ZoneCapacityService for putaway zone selection.
 * Single source of truth for all zone scoring weights.
 */

/** Base compatibility score for any zone */
export const ZONE_BASE_SCORE = 50;

/** Score bonus when zone type matches product's preferred zone types */
export const ZONE_PREFERRED_TYPE_BONUS = 20;

/** Score bonus when hazmat product is in HAZMAT zone */
export const ZONE_HAZMAT_MATCH_BONUS = 30;

/** Score bonus when high-value product is in HIGH_VALUE zone */
export const ZONE_HIGH_VALUE_MATCH_BONUS = 25;

// ---------------------------------------------------------------------------
// Temperature compatibility adjustments
// ---------------------------------------------------------------------------

/** Penalty when zone lacks temperature control but product requires it */
export const TEMP_NO_CONTROL_PENALTY = -20;

/** Bonus when zone temperature fully covers product range */
export const TEMP_FULL_MATCH_BONUS = 20;

/** Bonus when zone temperature partially overlaps product range */
export const TEMP_PARTIAL_MATCH_BONUS = 5;

/** Penalty when zone temperature is completely outside product range */
export const TEMP_NO_MATCH_PENALTY = -10;

// ---------------------------------------------------------------------------
// Humidity compatibility adjustments
// ---------------------------------------------------------------------------

/** Penalty when zone lacks humidity control but product requires it */
export const HUMIDITY_NO_CONTROL_PENALTY = -15;

/** Bonus when zone humidity fully covers product range */
export const HUMIDITY_FULL_MATCH_BONUS = 15;

/** Bonus when zone humidity partially overlaps product range */
export const HUMIDITY_PARTIAL_MATCH_BONUS = 5;

/** Penalty when zone humidity is completely outside product range */
export const HUMIDITY_NO_MATCH_PENALTY = -10;

// ---------------------------------------------------------------------------
// Zone type scoring weights (product characteristic → zone affinity)
// ---------------------------------------------------------------------------

export const ZONE_TYPE_SCORES = {
  COLD_STORAGE_TEMP_CONTROLLED: 10,
  FROZEN_PERISHABLE: 15,
  HAZMAT: 30,
  HIGH_VALUE: 25,
  STAGING: 5,
  PICKING: 8,
  BULK: 5,
} as const;

/** Bonus for preferred zone in putaway selection */
export const ZONE_PUTAWAY_PREFERRED_BONUS = 15;
